import {Fragment, useMemo} from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AgendaButtonFilterSelection} from '@/features/agenda/components/agenda-button-filter-selection/AgendaButtonFilterSelection'
import {AgendaSidebarDottedDivider} from '@/features/agenda/components/agenda-sidebar-dotted-divider/AgendaSidebarDottedDivider'
import {AgendaSidebarAccordion} from '@/features/agenda/components/agenda-sidebar-accordion/AgendaSidebarAccordion'
import {AgendaSidebarViewCard} from '@/features/agenda/components/agenda-sidebar-view-card/AgendaSidebarViewCard'
import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {UserSpecialization} from '@/features/users/types'
import {ObjectKeys, workServiceToLabel} from '@/utilities/helpers'
import {useGetUserSpecializations} from '@/features/users/queries/useGetUserSpecializations'
import {StyledAgendaSidebarViewContent} from '@/features/agenda/components/agenda-sidebar-view-card/style'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'
import {AgendaSearchParams} from '@/features/agenda/types'

export const AgendaSidebarViews = () => {
    const {
        searchParams: {specializationIds, category},
        setSearchParams
    } = useAgendaSearchParams()
    const {navigateToView} = useAgendaNavigation()

    const {remappedData: specializations} = useGetUserSpecializations({
        limit: 50
    })

    const handleClickSpecialization = (specialization: UserSpecialization) => {
        navigateToView('day')
        setSearchParams({
            patientId: undefined,
            subjectIds: undefined,
            category,
            specializationIds: [specialization.id]
        })
    }

    const accordionCategory = useMemo(() => {
        return category == 'evolutionary_age' || category == 'evolutionary_age_adults' || category == 'adults'
            ? category
            : null
    }, [category])

    const handleSetSelectedAccordion = (
        accordion: Extract<
            AgendaSearchParams['category'],
            'evolutionary_age' | 'evolutionary_age_adults' | 'adults'
        > | null
    ) => {
        setSearchParams({
            patientId: undefined,
            subjectIds: undefined,
            specializationIds: undefined,
            category: !accordion || category == accordion ? undefined : accordion
        })
    }

    return (
        <Flexbox direction="column" gap={1} fullWidth>
            <AgendaSidebarDottedDivider />
            {ObjectKeys(workServiceToLabel).map(
                (viewGroup, index) =>
                    viewGroup.length > 0 && (
                        <Fragment key={index}>
                            <AgendaSidebarAccordion
                                accordionItemLabel={viewGroup}
                                setSelectedAccordion={() => handleSetSelectedAccordion(viewGroup)}
                                selectedAccordion={accordionCategory}
                            >
                                <StyledAgendaSidebarViewContent gap={1} direction="column" fullWidth>
                                    {specializations?.map(specialization => {
                                        return !specializationIds?.includes(specialization.id) ? (
                                            <AgendaButtonFilterSelection
                                                key={specialization.id}
                                                onClick={() => handleClickSpecialization(specialization)}
                                            >
                                                {specialization.name}
                                            </AgendaButtonFilterSelection>
                                        ) : (
                                            <AgendaSidebarViewCard
                                                key={specialization.id}
                                                specializationId={specialization.id}
                                                specializationName={specialization.name}
                                            />
                                        )
                                    })}
                                </StyledAgendaSidebarViewContent>
                            </AgendaSidebarAccordion>
                            <AgendaSidebarDottedDivider />
                        </Fragment>
                    )
            )}
        </Flexbox>
    )
}
